import React, { useEffect } from "react";
import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import Textarea from "@peracto/peracto-editor-ui/dist/Textarea";
import File from "@peracto/peracto-editor-ui/dist/File";
import Select from "@peracto/peracto-editor-ui/dist/Select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";

const PanelGridForm = ({
    onChange,
    state: { panels = [], heading = "Panel Grid", selectedCardIndex },
}) => {
    const DEFAULT_PANEL = {
        heading: "Panel heading",
        text: "",
        backgroundImage: "",
        buttonText: "",
        buttonLink: "",
        buttonColour: "primary",
    };

    const buttonColourOptions = [
        { label: "Primary", value: "primary" },
        { label: "Secondary", value: "secondary" },
    ];

    useEffect(() => {
        return () => {
            onChange({ selectedCardIndex: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <TextInput
                label="Heading"
                onChange={(e) => {
                    onChange({ heading: e.target.value });
                }}
                value={heading}
            />
            {panels?.length === 0 && (
                <>
                    <p>Click 'Add Panel' to get started</p>
                    <hr />
                </>
            )}
            {selectedCardIndex !== null &&
                panels &&
                panels[selectedCardIndex] && (
                    <>
                        <TextInput
                            label="Panel Heading"
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].heading =
                                    e.target.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            value={panels[selectedCardIndex].heading}
                        />

                        <Textarea
                            label="Text"
                            value={panels[selectedCardIndex].text}
                            height={300}
                            onChange={(e, editor) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].text =
                                    editor.getData();

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                        />

                        <File
                            label="Background Image"
                            value={panels[selectedCardIndex].backgroundImage}
                            onChange={(value) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].backgroundImage =
                                    value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            isInline={false}
                        />

                        <TextInput
                            label="Button Text"
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].buttonText =
                                    e.target.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            value={panels[selectedCardIndex].buttonText}
                        />

                        <TextInput
                            label="Button Link"
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].buttonLink =
                                    e.target.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            value={panels[selectedCardIndex].buttonLink}
                        />

                        <Select
                            label="Button Colour"
                            value={panels[selectedCardIndex].buttonColour}
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].buttonColour =
                                    e.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            options={buttonColourOptions}
                        />

                        <button
                            className="btn btn-sm btn-danger w-100 mt-2"
                            onClick={(e) => {
                                const panelsClone = [...panels];

                                panelsClone.splice(selectedCardIndex, 1);

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />{" "}
                            Remove Panel
                        </button>
                    </>
                )}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    e.preventDefault();

                    const panelsClone = [...panels, DEFAULT_PANEL];
                    onChange({
                        panels: panelsClone,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add
                Panel
            </button>
        </>
    );
};

export default PanelGridForm;
